import React from "react";
import { CloseButton } from "@components/CloseButton";
import './Modal.scss';

type ModalProps = {
  marginTop: string;
  children?: JSX.Element[] | JSX.Element;
  alignItems: string;
  onClose?: () => void;
};

export const Modal = ({ marginTop, children, alignItems, onClose }: ModalProps) => {
  return (
    <div
      className={"c-hex-modal-container"}
      style={{
        marginTop: marginTop,
        alignItems: alignItems,
      }}
    >
      <div
        className={"c-hex-modal-inner-container"}
      >
        {onClose && <CloseButton onClick={onClose} />}
        {children}
      </div>
    </div>
  );
};
